//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { useSelector } from 'react-redux';

import { getIsMediaLibraryStreamsEnabled } from '@media-library/redux/getMediaLibraryPage';

// TODO: PD-319070 - Remove streams/collections branching once media_library_streams is released
export const getStreamEntityLabels = (isStreamsEnabled: boolean) => ({
  entityLabel: isStreamsEnabled ? 'Stream' : 'Collection',
  entityLabelLower: isStreamsEnabled ? 'stream' : 'collection',
});

// TODO: PD-319070 - Remove streams/collections branching once media_library_streams is released
export const useStreamEntityLabels = () => {
  const isStreamsEnabled = useSelector(getIsMediaLibraryStreamsEnabled);
  return getStreamEntityLabels(isStreamsEnabled);
};
